<template>
  <Modal v-if="show">
    <template slot="header">
      <h3 class="title">Wygeneruj raport XLS</h3>
      <md-button
        class="md-simple md-just-icon md-round modal-default-button"
        @click="close()"
      >
        <md-icon>clear</md-icon>
      </md-button>
    </template>
    <template slot="body">
      <md-datepicker
        v-model="dateStart"
        :md-disabled-dates="disabledDatesStart"
      >
        <label>Data początku</label>
      </md-datepicker>
      <md-datepicker v-model="dateEnd" :md-disabled-dates="disabledDatesEnd">
        <label>Data końca</label>
      </md-datepicker>
    </template>
    <template slot="footer">
      <md-button
        class="md-info"
        :disabled="!dateStart || !dateEnd"
        @click="getRaport()"
        >Wygeneruj</md-button
      >
    </template>
  </Modal>
</template>

<script>
import Modal from './Modal'
export default {
  components: {
    Modal,
  },
  name: 'RaportModal',
  data() {
    return {
      show: false,
      dateStart: this.setDateStart(),
      dateEnd: new Date(),
      disabledDatesEnd: date => {
        return date < this.dateStart
      },
      disabledDatesStart: date => {
        if (this.dateEnd !== null) {
          return date > this.dateEnd
        }
      },
    }
  },
  methods: {
    setDateStart() {
      let today = new Date()
      return new Date(new Date(today).setDate(today.getDate() - 90))
    },
    open() {
      this.show = true
    },
    close() {
      this.show = false
    },
    getRaport() {
      const options = {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
      }
      let dateRange = {
        from: this.dateStart.toLocaleDateString('en-GB', options),
        to: this.dateEnd.toLocaleDateString('en-GB', options),
      }
      this.$store
        .dispatch('getRaport', {
          dateRange,
        })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'raport.xlsx')
          document.body.appendChild(link)
          link.click()
          this.close()
        })
    },
  },
}
</script>

<style scoped></style>
